<i18n>
{
    "de": {
        "type": "Typ",
        "colour": "Farbe"
    },
    "en": {
        "type": "Type",
        "colour": "Colour"
    }
}
</i18n>

<template>
  <div>
    <div class="c-equipmenttable" v-if="JSON.parse(entry.tabelle).length > 0">
      <!-- <div class="row c-equipmenttable__header py-2"> -->
      <div class="c-equipmenttable__header">Code</div>
      <div class="c-equipmenttable__header">{{ $t("type") }}</div>
      <div class="c-equipmenttable__header">{{ $t("colour") }}</div>
      <!-- </div> -->
      <template v-for="(row, rowIndex) in JSON.parse(entry.tabelle)">
        <div
          v-for="(col, colIndex) in row"
          :key="rowIndex + '-' + colIndex"
          v-html="col"
          class="py-2"
        ></div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    entry: {
      required: true,
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
